import { getMainTypeFromSystemType } from "../../../../infra/protected/FPA/FPAData";
import type { PathSegmentContextRef } from "../../../../infra/protected/Search/SearchResultData";
import type { ContextList } from "../../../../services/soap/project/responses/GetContextPathResponse";
import type { ContextObject, ContextTypeKind } from "./types";

/**
 * Maps GetContextPath `LIST` to {@link ContextObject} for the same breadcrumb
 * strategy as search-driven selection (`breadcrumbs` then title = root → leaf).
 *
 * The service returns `LIST` leaf → root (deepest context first); we reverse so
 * path segments match UI and the resolved leaf is the requested context.
 */
export function contextObjectFromGetContextPathList(
  list: ContextList[] | undefined
): ContextObject | null {
  if (!list?.length) {
    return null;
  }

  const ordered = [...list].reverse();

  const pathSegments: string[] = [];
  const pathSegmentContexts: PathSegmentContextRef[] = [];

  for (const entry of ordered) {
    const c = entry?.CONTEXT;
    if (!c) {
      return null;
    }
    const name = (c.name ?? "").trim();
    if (!name) {
      return null;
    }
    const main = getMainTypeFromSystemType(+c.systemType);
    if (main === "NONE") {
      return null;
    }
    pathSegments.push(name);
    const refRaw = c.refId;
    const refTrimmed =
      refRaw != null && String(refRaw).trim() ? String(refRaw).trim() : "";
    pathSegmentContexts.push({
      id: c.id,
      type: main as PathSegmentContextRef["type"],
      ...(refTrimmed ? { refId: refTrimmed } : {}),
    });
  }

  const leaf = ordered[ordered.length - 1].CONTEXT;
  const leafMain = getMainTypeFromSystemType(+leaf.systemType);
  if (leafMain === "NONE") {
    return null;
  }

  let folderTypeId: number | undefined = ordered[0].CONTEXT?.type;
  
  return {
    contextId: leaf.id,
    contextType: leafMain as ContextTypeKind,
    link: "",
    pathSegments,
    pathSegmentContexts,
    ...(folderTypeId != null ? { folderTypeId } : {}),
  };
}
